import "../icon-svg.less";

const IconEdit = ({ className = "" }: { className?: string }) => (
  <svg className={`icon-svg icon-edit ${className}`} viewBox="0 0 16 16" version="1.1" fill="none">
    <g id="icon/&#232;&#175;&#132;&#232;&#174;&#186;">
      <g id="Group 133">
        <g id="Group 134">
          <path
            id="Vector"
            d="M2 14H14"
            stroke="currentColor"
            strokeWidth="0.999992"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            id="Vector_2"
            d="M3.33325 8.90652V11.3332H5.77232L12.6666 4.43599L10.2316 2L3.33325 8.90652Z"
            stroke="currentColor"
            strokeWidth="0.999992"
            strokeLinejoin="round"
          />
        </g>
      </g>
    </g>
  </svg>
);

export default IconEdit;
